import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PasswordSuccessResult } from 'components/auth';
import { WAREHOUSE_ROUTES } from 'constants/routes';
import WarehouseAuthContainer from '../components/WarehouseAuthContainer';

const WarehousePasswordSuccess: React.FC = () => {
  const navigate = useNavigate();

  const handleGoToSignIn = () => {
    navigate(WAREHOUSE_ROUTES.warehouseSignIn);
  };

  return (
    <WarehouseAuthContainer
      title="Password Set Up Successfully"
      description="Your password has been set up successfully. You can now sign in to your account."
      showERPLink={false}
    >
      <PasswordSuccessResult
        title="Password Set Up Successfully"
        subtitle="Your password has been set up successfully. You can now sign in to your account."
        buttonText="Go to Sign In"
        onButtonClick={handleGoToSignIn}
      />
    </WarehouseAuthContainer>
  );
};

export default WarehousePasswordSuccess;
